import Vue from 'vue';
import Root from './Root.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Validator from './Validator';

Vue.config.productionTip = false;

Vue.use(Validator);

console.log('ver 0.17.0');

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(Root),
}).$mount('#app');
